import { AdventureSelect, Loader, QueryBoundary } from '@outdoria/ui';
import { useAppContext } from '../../../utils/context';
import { Breadcrumbs } from '../Breadcrumbs';

import s from './Header.module.scss';

export const Header = () => (
  <QueryBoundary fallback={<Header.Skeleton />}>
    <Load />
  </QueryBoundary>
);

const Load = () => {
  const { adventure, setAdventure } = useAppContext();

  const onAdventureSwitch = (id: string) => {
    setAdventure({ id });
  };

  return (
    <header className={s.header}>
      <div className={s.header__adventureSelect}>
        <AdventureSelect
          currentAdventure={adventure}
          onAdventureSwitch={onAdventureSwitch}
        />
      </div>

      <Breadcrumbs />
    </header>
  );
};

Header.Skeleton = () => (
  <header className={s.header}>
    <Loader />
  </header>
);
